import { IonApp, setupIonicReact } from "@ionic/react";
import { ToastContainer } from "react-toastify";
import Routes from "routes";
import "moment/locale/id";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

import "styles/index.scss";

setupIonicReact({
  mode: "md",
});

const App = () => {
  document.body.classList.remove("dark");
  return (
    <IonApp id="app">
      <Routes />
      <ToastContainer />
    </IonApp>
  );
};

export default App;
